import { Link } from "react-router-dom";
import { ShieldCheck, Lock, Eye } from "lucide-react";
import { Steps } from "@/pages/Home";
import { useSeo } from "@/lib/draft";

export const PageHead = ({ eyebrow, title, text }) => (
  <section className="bg-[#092C66] text-white">
    <div className="wrap py-14 md:py-20">
      <p className="eyebrow !text-[#3198EF]">{eyebrow}</p>
      <h1 className="mt-3 max-w-3xl text-4xl font-extrabold leading-tight sm:text-5xl" data-testid="page-title">{title}</h1>
      {text && <p className="mt-4 max-w-2xl text-base text-[#EDF5FF]/85 md:text-lg">{text}</p>}
    </div>
  </section>
);

export default function ComoFunciona() {
  useSeo("Como funciona", "Entenda como enviar e acompanhar uma solicitação jurídica pela Conexão Litigium em poucos passos.");
  return (
    <>
      <PageHead eyebrow="Como funciona" title="Do relato ao acompanhamento, tudo organizado." text="Você descreve sua situação antes de qualquer cadastro. Seus dados só são pedidos no momento do envio." />
      <section className="wrap mt-12"><Steps /></section>
      <section className="wrap mt-14 grid gap-4 md:grid-cols-3">
        {[
          [Lock, "Privacidade", "Seus relatos ficam acessíveis apenas ao responsável pelo atendimento. Nada é publicado."],
          [Eye, "Transparência", "Você acompanha o status administrativo real de cada solicitação pelo protocolo."],
          [ShieldCheck, "Sem promessas", "O envio não garante atendimento imediato, não suspende prazos e não implica contratação."],
        ].map(([I, t, d]) => (
          <div key={t} className="card"><I className="text-[#1465C8]" /><h3 className="mt-3 text-lg font-bold">{t}</h3><p className="mt-1 text-sm text-[#64748B]">{d}</p></div>
        ))}
      </section>
      <section className="wrap mt-12"><Link to="/solicitar" className="btn-primary" data-testid="how-start-btn">Iniciar solicitação</Link></section>
    </>
  );
}
